import MongoId from 'mongoid-js';

import { CALL_API } from '../../api';
import schema from '../../api/schema';

import * as ActionTypes from './inspection.actionTypes';

const apiReadInspectionTypes = (company) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_INSPECTION_TYPES_REQUEST,
      ActionTypes.READ_INSPECTION_TYPES_SUCCESS,
      ActionTypes.READ_INSPECTION_TYPES_FAILURE,
    ],
    endpoint: `inspection/availableTypes?company=${company}`,
    schema: schema.inspectionTypesSchema,
    authorization: true,
  },
});

export const readInspectionTypes = (company) => (dispatch, getState) => {
  if (getState().entities.inspectionType.allIds.length > 0 || company === null) {
    return Promise.resolve();
  }
  return dispatch(apiReadInspectionTypes(company));
};

const apiReadInspection = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_INSPECTION_REQUEST,
      ActionTypes.READ_INSPECTION_SUCCESS,
      ActionTypes.READ_INSPECTION_FAILURE,
    ],
    endpoint: `inspection/${id}`,
    schema: schema.inspectionSchema,
    authorization: true,
  },
  payload: {
    id,
  },
});

export const readInspection = id => (dispatch, getState) => {
  const inspection = getState().entities.inspection.byId[id];
  // Read inspection expects to get full inspection object, not just metadata
  if (inspection && inspection.formData) {
    return Promise.resolve();
  }
  return dispatch(apiReadInspection(id));
};

const apiUploadImage = (id, data) => ({
  [CALL_API]: {
    types: [ActionTypes.UPLOAD_IMAGE_REQUEST, ActionTypes.UPLOAD_IMAGE_SUCCESS, ActionTypes.UPLOAD_IMAGE_FAILURE],
    endpoint: `inspection/image/${id}`,
    // schema: schema.inspectionSchema,
    authorization: true,
    requestInit: {
      method: 'POST',
      body: data,
    },
  },
});

export const uploadImage = (id, data) => (dispatch, getState) => {
  return dispatch(apiUploadImage(id, data));
};

export const generateInspectionId = type => (dispatch, getState) => {
  const id = MongoId();

  return dispatch({
    type: ActionTypes.GENERATE_INSPECTION_ID,
    inspectionType: type,
    id,
  });
};

const apiCreateInspection = (data, auth, tempId, dispatch) => ({
  type: ActionTypes.CREATE_INSPECTION_REQUEST,
  payload: { tempId, type: data.type },
  meta: {
    offline: {
      effect: {
        auth: auth,
        endpoint: 'inspection',
        schema: schema.inspectionSchema,
        authorization: true,
        requestInit: {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(data),
        },
      },
      commit: {
        type: ActionTypes.CREATE_INSPECTION_SUCCESS,
        meta: { tempId, dispatch },
      },
      rollback: {
        type: ActionTypes.CREATE_INSPECTION_FAILURE,
        meta: { tempId },
      },
    },
  },
});

export const createInspection = (data, id) => (dispatch, getState) => {
  const auth = getState().auth;
  return dispatch(apiCreateInspection(data, auth, id, dispatch));
};
export const apiUpdateInspection = data => ({
  type: ActionTypes.UPDATE_INSPECTION_REQUEST,
  meta: {
    offline: {
      effect: {
        endpoint: `inspection/${data.formData._id}`,
        schema: schema.inspectionSchema,
        authorization: true,
        requestInit: {
          method: 'PUT',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(data),
        },
      },
      commit: {
        type: ActionTypes.UPDATE_INSPECTION_SUCCESS,
      },
      rollback: {
        type: ActionTypes.UPDATE_INSPECTION_FAILURE,
      },
    },
  },
  payload: {
    data: data,
  },
});

export const updateInspection = data => (dispatch, getState) => {
  return dispatch(apiUpdateInspection(data));
};

export const updateGeneratedInspection = data => dispatch => {
  return dispatch({
    type: ActionTypes.UPDATE_GENERATED_INSPECTION,
    data: data,
  });
};
const apiDeleteInspection = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.DELETE_INSPECTION_REQUEST,
      ActionTypes.DELETE_INSPECTION_SUCCESS,
      ActionTypes.DELETE_INSPECTION_FAILURE,
    ],
    endpoint: `inspection/${id}`,
    authorization: true,
    requestInit: {
      method: 'DELETE',
    },
  },
  payload: {
    id,
  },
});

export const deleteInspection = id => (dispatch, getState) => {
  return dispatch(apiDeleteInspection(id));
};

const apiCopyInspection = id => ({
  [CALL_API]: {
    types: [
      ActionTypes.COPY_INSPECTION_REQUEST,
      ActionTypes.COPY_INSPECTION_SUCCESS,
      ActionTypes.COPY_INSPECTION_FAILURE,
    ],
    endpoint: `inspection/copy/${id}`,
    authorization: true,
    requestInit: {
      method: 'POST',
    },
  },
});

export const copyInspection = id => (dispatch, getState) => {
  return dispatch(apiCopyInspection(id));
};

const apiReadInspections = (params) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_INSPECTIONS_REQUEST,
      ActionTypes.READ_INSPECTIONS_SUCCESS,
      ActionTypes.READ_INSPECTIONS_FAILURE,
    ],
    schema: schema.inspectionsSchema,
    endpoint: params ? `inspection/?params=${params}` : 'inspection',
    authorization: true,
    actualRequestKey: 'readInspections' // we want only latest results to be processed
  },
});

export const readInspections = (params = {}) => (dispatch, getState) => {
  const state = getState();
  try {
    params = {
      ...state.entities.reports,
      ...params,
    };
    params.filters = params.filters.map((filter) => JSON.stringify(
      {
        field: filter.field,
        value: filter.value.value
      }
    ));

  } catch (error) {
    console.error(error);
  }
  return dispatch(apiReadInspections(JSON.stringify(params)));
};

const apiReadInspectionSchemas = (company) => ({
  [CALL_API]: {
    types: [
      ActionTypes.READ_INSPECTION_SCHEMAS_REQUEST,
      ActionTypes.READ_INSPECTION_SCHEMAS_SUCCESS,
      ActionTypes.READ_INSPECTION_SCHEMAS_FAILURE,
    ],
    schema: schema.formSchemasSchema,
    endpoint: `inspection/schemas?company=${company}`,
    authorization: true,
  },
});

export const readInspectionSchemas = (company) => (dispatch, getState) => {
  if (company === null) {
    return Promise.resolve();
  }
  return dispatch(apiReadInspectionSchemas(company));
};

const apiReadFormDatas = () => ({
  [CALL_API]: {
    types: [ActionTypes.READ_FORMDATAS_REQUEST, ActionTypes.READ_FORMDATAS_SUCCESS, ActionTypes.READ_FORMDATAS_FAILURE],
    schema: schema.formDataArraySchema,
    endpoint: 'inspection/formData',
    authorization: true,
  },
});

export const readFormDatas = () => (dispatch, getState) => {
  return dispatch(apiReadFormDatas());
};

const apiExportInspections = ids => ({
  [CALL_API]: {
    types: [
      ActionTypes.EXPORT_INSPECTION_REQUEST,
      ActionTypes.EXPORT_INSPECTION_SUCCESS,
      ActionTypes.EXPORT_INSPECTION_FAILURE,
    ],
    endpoint: `inspection/export?${ids}`,
    authorization: true,
  },
});

export const exportInspections = ids => (dispatch, getState) => {
  let query = [];
  ids.forEach((element, i) => {
    query.push(`inspectionIds[${i}]=${element}`);
  });
  return dispatch(apiExportInspections(query.join('&')));
};

const apiExportInspectionsAsXlsx = ids => ({
  [CALL_API]: {
    types: [
      ActionTypes.EXPORT_INSPECTION_REQUEST,
      ActionTypes.EXPORT_INSPECTION_SUCCESS,
      ActionTypes.EXPORT_INSPECTION_FAILURE,
    ],
    endpoint: `inspection/export-xlsx?${ids}`,
    authorization: true,
  },
});

export const exportInspectionsAsXlsx = ids => (dispatch, getState) => {
  let query = [];
  ids.forEach((element, i) => {
    query.push(`inspectionIds[${i}]=${element}`);
  });
  return dispatch(apiExportInspectionsAsXlsx(query.join('&')));
};

const apiSendWorkorder = (ids, data) => ({
  [CALL_API]: {
    types: [
      ActionTypes.EXPORT_INSPECTION_REQUEST,
      ActionTypes.EXPORT_INSPECTION_SUCCESS,
      ActionTypes.EXPORT_INSPECTION_FAILURE,
    ],
    endpoint: `inspection/workorder?${ids}`,
    authorization: true,
    requestInit: {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data),
    },
  },
});

export const sendWorkorder = (ids, workdorderEmails = [], workdorderSub = "", workdorderMsg = "") => (dispatch, getState) => {
  let query = [];
  let data = {woEmail: workdorderEmails, woSub: workdorderSub, woMsg: workdorderMsg};
  ids.forEach((element, i) => {
    query.push(`inspectionIds[${i}]=${element}`);
  });
  return dispatch(apiSendWorkorder(query.join('&'), data));
};

// const apiGetAvailableFilters = () => ({
//   [CALL_API]: {
//     types: [
//       ActionTypes.READ_FILTERS_REQUEST,
//       ActionTypes.READ_FILTERS_SUCCESS,
//       ActionTypes.READ_FILTERS_FAILURE,
//     ],
//     schema: schema.inspectionsSchema,
//     endpoint: 'inspection/availableFilters',
//     authorization: true,
//   },
// });

// export const getAvailableFilters = () => (dispatch, getState) => {
//   return dispatch(apiGetAvailableFilters());
// };



// WEBPACK FOOTER //
// ./src/modules/inspection/inspection.actions.js